// opervex-frontend/src/components/DynamicTable/CustomTableRow.js

import React from "react";
import { FormCheck } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import OpervexStorage from "../../utils/OpervexStorage";

const CustomTableRow = ({ row, layout, links, index }) => {
  const tenantId = OpervexStorage.getTenantIdFromPath();

  return (
    <tr key={index}>
      {layout.map(
        (col) =>
          col.visible &&
          (() => {
            const { align = "center", ...style } = col.style || {};

            return (
              <td
                key={col.key}
                className="align-middle"
                style={{
                  ...style,
                  textAlign: align,
                }}
              >
                {col.type === "boolean" ? (
                  <FormCheck type="checkbox" checked={row[col.key]} readOnly />
                ) : (
                  (() => {
                    const linkObj = Array.isArray(links) ? links.find((l) => l.key === col.key) : null;

                    const formatDate = (value) => {
                      if (!value) return "";

                      const [datePart, timePart = "00:00:00"] = value.split(" ");

                      const [year, month, day] = datePart.split("-");
                      const [hour, minute, second] = timePart.split(":");

                      return format(
                        new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)),
                        "dd/MM/yyyy HH:mm:ss",
                      );
                    };

                    const formatDateOnly = (value) => {
                      if (!value) return "";

                      const [year, month, day] = value.split("-");

                      return format(new Date(Number(year), Number(month) - 1, Number(day)), "dd/MM/yyyy");
                    };

                    const formattedValue =
                      col.type === "date"
                        ? formatDate(row[col.key])
                        : col.type === "integer" || col.type === "number"
                          ? Number(row[col.key]) === 0
                            ? ""
                            : new Intl.NumberFormat("pt-BR", {
                                maximumFractionDigits: 0,
                              }).format(row[col.key])
                          : col.type === "decimal"
                            ? new Intl.NumberFormat("pt-BR", {
                                minimumFractionDigits: col.decimals,
                                maximumFractionDigits: col.decimals,
                              }).format(row[col.key])
                            : col.type === "currency"
                              ? new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(row[col.key])
                              : col.type === "dateOnly"
                                ? formatDateOnly(row[col.key])
                                : row[col.key];

                    if (linkObj && row[col.key]) {
                      const url = "/" + tenantId + linkObj.link.replace(":id", row[col.key]);

                      return linkObj.newPage ? (
                        <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                          {formattedValue}
                        </a>
                      ) : (
                        <Link to={url} className="text-primary text-decoration-none">
                          {formattedValue}
                        </Link>
                      );
                    }

                    if (col?.cellStyles) {
                      const cell = col.cellStyles.find((x) => x.value === row[col.key]);

                      if (cell) return <div className={cell.className}>{formattedValue}</div>;
                    }

                    return formattedValue;
                  })()
                )}
              </td>
            );
          })(),
      )}
    </tr>
  );
};

export default CustomTableRow;
